import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { DownloadArquivoSistema } from 'src/services/downloadFileUrl';
import List from 'src/componentes/list';
import ListColumn from 'src/componentes/list/list-column';
import CargoEdit from './edit';
import ContentManager from 'src/componentes/content-manager';
import ValidacaoRestricao from 'src/paginas/item/validacao-restricao';
import http from 'src/services/httpService';
import { FILTROS, MODULOS } from 'src/utils/constants';
import errorHandler from 'src/utils/error-handler';
import Search from './search';
import SearchSchema from './search-schema';
import LucideIcon from 'src/componentes/lucide-icon';

function Cargo(props) {
  const intl = useIntl();
  const modulosComprados = useSelector((state) => state.user.licenca.modulos);
  const [saved, setSaved] = useState(false);
  const [
    contratoResultadosVinculadoCargo,
    setContratoResultadosVinculadoCargo,
  ] = useState(false);

  useEffect(() => {
    let active = true;

    http
      .post('/CardMeta/ObterConfiguracaoContratoResultados', {})
      .then((response) => {
        if (active) {
          setContratoResultadosVinculadoCargo(
            response.data.contratoResultadosVinculadoCargo
          );
        }
      })
      .catch((error) => {
        if (active) errorHandler(error);
      });

    return () => {
      active = false;
    };
  }, []);

  const handleRefresh = () => {
    setSaved((previousSaved) => !previousSaved);
  };

  const handleDeleteClick = (item) => {
    ContentManager.addContent(
      <ValidacaoRestricao
        url="/Cargo/ValidarRestricoes"
        urlExclusao="/Cargo/Remove"
        item={item}
        afterRemove={handleRefresh}
        urlEdit="/Cargo/edit"
        isEdit={true}
      />
    );
  };

  const renderNome = (item) => {
    const handleEdit = () => {
      ContentManager.addContent(
        <CargoEdit
          handleClose={(wasSaved) => {
            if (wasSaved) handleRefresh();
          }}
          item={item}
          showDelete={true}
        />
      );
    };

    return (
      <a
        className="font-weight-bold text-primary cursor-pointer"
        onClick={handleEdit}
      >
        {item.nome}
      </a>
    );
  };

  const renderCriticidade = (item) => {
    return <span>{item.criticidade && item.criticidade.nome}</span>;
  };

  const renderTipo = (item) => {
    return <span>{item.tipoCargo && item.tipoCargo.nome}</span>;
  };

  const renderModeloBonificacao = (item) => {
    return (
      <span
        title={intl.formatMessage({ id: 'label.download' })}
        style={{ marginRight: '8px' }}
      >
        {item.modeloBonificacaoGuid ? (
          <LucideIcon
            icon="Download"
            className="cursor-pointer"
            size={20}
            onClick={(event) => {
              event.stopPropagation();
              DownloadArquivoSistema(item.modeloBonificacaoGuid);
            }}
          />
        ) : (
          ''
        )}
      </span>
    );
  };

  const hasRV = modulosComprados.some(
    (m) => m.id === MODULOS.REMUNERACAO_VARIAVEL && m.ativo
  );

  return (
    <List
      changedColumns={contratoResultadosVinculadoCargo}
      url="/Cargo"
      editComponent={CargoEdit}
      sort="Nome"
      showSearch={true}
      saved={saved}
      {...props}
      tag={11002}
      onDeleting={handleDeleteClick}
      searchComponent={<Search />}
      searchSchema={SearchSchema}
      filtroId={FILTROS.CARGOS}
      filterDrawer
    >
      <ListColumn
        headerText={intl.formatMessage({ id: 'nome' })}
        valueField="nome"
        valueFunction={renderNome}
        required
        default
      />
      <ListColumn
        headerText={intl.formatMessage({ id: 'tipo' })}
        valueFunction={renderTipo}
        valueField="tipoCargo"
        default
      />
      <ListColumn
        headerText={intl.formatMessage({ id: 'descricao' })}
        valueField="descricao"
        default
      />
      <ListColumn
        headerText={intl.formatMessage({ id: 'idIntegracao' })}
        valueField="idIntegracao"
        sortField="idIntegracao"
      />
      <ListColumn
        headerText={intl.formatMessage({ id: 'criticidade' })}
        valueFunction={renderCriticidade}
        valueField="criticidade"
        sortField="criticidade.Nome"
      />
      <ListColumn
        headerText={intl.formatMessage({ id: 'modeloBonificacao' })}
        valueFunction={renderModeloBonificacao}
        valueField="modeloBonificacaoGuid"
        visible={hasRV && contratoResultadosVinculadoCargo}
        center
      />
    </List>
  );
}

export default Cargo;
